import { get, find } from 'lodash';
import React from 'react';
import moment from 'moment';

export default {
  photoId: {
    accessor: 'photoId',
    title: 'Customer Picture',
    formatter: (_, entry) => (
      <div className="c-customer-avatar">
        <img alt="" src={get(entry, 'photoUrl')} />
      </div>
    ),
    onChange: (entry, duplicates) => {
      if (!entry.photoId) {
        entry.photoUrl = null;
        return entry;
      }

      const duplicate = find(duplicates, { photoId: entry.photoId });
      entry.photoUrl = duplicate.photoUrl;
    },
  },
  firstName: {
    accessor: 'firstName',
    title: 'First Name',
  },
  lastName: {
    accessor: 'lastName',
    title: 'Last Name',
  },
  phone: {
    accessor: 'phone',
    title: 'Phone',
  },
  email: {
    accessor: 'email',
    title: 'E-mail',
  },
  birthDate: {
    accessor: 'birthDate',
    title: 'Birthday',
    formatter: value => (value ? moment(value).format('DD MMM YYYY') : 'Not set'),
  },
  unsubscribedCampaign: {
    accessor: 'unsubscribedCampaign',
    title: 'Unsubscribed From Campaigns',
    formatter: value => (value ? 'Yes' : 'No'),
  },
  blockNoShowFromBookNoPay: {
    accessor: 'blockNoShowFromBookNoPay',
    title: 'Only Prepay',
    formatter: value => (value ? 'Yes' : 'No'),
  },
};
